import API from "../../../API/API";

const endPoints = "me";

export const getCurrentUserDetailsApi = async () => {
    // Create a fresh API instance for each request to ensure token is read from localStorage at request time
    const api = new API();
    // Debug: Log token status
    const token = localStorage.getItem("token");
    return new Promise(async (resolve, reject) => {
        try {
            const result = await api.get(endPoints);
            resolve(result);

        } catch (error) {
            console.error("❌ getCurrentUserDetailsApi error:", error.response?.status, error.response?.data);
            reject(error);
        }
    });
};
